import { useState, useEffect } from "react";
import { useTheme } from "styled-components";
import { Wrapper, Card, Title, Label, Overlay } from "../CommonComponents/DataCard";
import Spinner from "../CommonComponents/Spinner";
import { getAuthorById } from "../../services/AuthorService";
import { getCurrentUser } from "../../services/AuthService";
import Button from "../CommonComponents/Button";
import { ROLES } from "../../services/Constants";
import { useNavigate } from "react-router-dom";
import EditAuthorModal from "../AuthorComponents/EditAuthorModal";

function AuthorModal({ isOpen, onClose, id }) {
    const theme = useTheme();
    const [author, setAuthor] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [showEdit, setShowEdit] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isOpen || !id) return;

        const fetchData = async () => {
            setLoading(true);
            setError("");
            try {
                const userData = await getCurrentUser();
                if (userData.authenticated === true) {
                    setCurrentUser(userData);
                } else {
                    setCurrentUser(null);
                }
            } catch (err) {
                setCurrentUser(null);
            }
            try {
                const authorData = await getAuthorById(id);
                setAuthor(authorData);
            } catch (err) {
                setError(err.message || "Greška prilikom učitavanja podataka");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [isOpen, id]);

    const handleGetAuthorBooks = () => {
        if (!author) return;
        const authorQuery = `${author.name} ${author.surname}`;
        navigate(`/pretrazi?q=${encodeURIComponent(authorQuery)}&f=author&page=0`);
        onClose();
    };


    if (!isOpen) return null;

    return (
        <Overlay onClick={onClose}>
            <Wrapper
                style={{
                    maxWidth: "500px",
                    width: "90%",
                    minHeight: 0,
                    margin: 0,
                    padding: 0
                }}
                onClick={e => e.stopPropagation()}
            >
                <Card style={{
                    margin: 0,
                }}>
                    {loading ? (
                        <Spinner />
                    ) : error ? (
                        <div style={{ color: "red" }}>{error}</div>
                    ) : (
                        <>
                            <Title>{author.name} {author.surname}</Title>
                            <Label>Datum rođenja: {author.dateOfBirth}</Label>
                            <Label>Mjesto rođenja: {author.placeOfBirth}</Label>
                            <Label>Datum smrti: {author.dateOfDeath || "N/A"}</Label>
                            <Label>Mjesto smrti: {author.placeOfDeath || "N/A"}</Label>
                            <Label>
                                Biografija:{" "}
                                {author.biography
                                    ? (() => {
                                        try {
                                            const url = new URL(author.biography);
                                            if (url.protocol === "http:" || url.protocol === "https:") {
                                                return (
                                                    <a
                                                        href={author.biography}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: theme.colors.primary, fontWeight: 600 }}
                                                    >
                                                        {author.biography}
                                                    </a>
                                                );
                                            }
                                        } catch { /* nije URL */ }
                                        return <span style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{author.biography}</span>;
                                    })()
                                    : "N/A"}
                            </Label>

                            <div style={{ display: "flex", gap: "8px", marginTop: "16px" }}>
                                <Button tekst={"Pregledaj i ostala djela"} akcija={handleGetAuthorBooks} />
                                {(currentUser?.role === ROLES.EMPLOYEE || currentUser?.role === ROLES.ADMIN) && (
                                    <Button
                                        tekst={"Uredi autora"}
                                        akcija={() => setShowEdit(true)}
                                    />
                                )}
                            </div>
                        </>
                    )}
                </Card>
            </Wrapper>
            {showEdit && (
                <EditAuthorModal
                    isOpen={showEdit}
                    onClose={() => setShowEdit(false)}
                    id={author.id}
                    onAuthorUpdated={(updatedAuthor) => setAuthor(updatedAuthor)}
                />
            )}
        </Overlay>
    );
}

export default AuthorModal;
